// extracted by mini-css-extract-plugin
module.exports = {"featured-image":"FeaturedImage_featured-image__Dg4PY"};